import QrCode2Icon from '@mui/icons-material/QrCode2';
import { Tooltip, Typography } from "@mui/material";
import { useState } from 'react';
import { useDispatch } from "react-redux";
import { openNewForm } from "../../../../../actions/formsState";
import CircularLoading from "../../../../commons/loadingData/circularLoading";
import { StyledAddDocumentationCards } from "../../../../styled/accident";
import OpenFormQRDialogContainer from "../../../forms/qrOpenform/OpenFormQRDialogContainer";

const AddDocumentationCards = ({ data, loading }) => {
  const dispatch = useDispatch();

  const [qrForm, setQRform] = useState(null);

  const handleOpenAddFormQr = (form) => {
    setQRform(form);
  }

  const handleOpenAddForm = (form) => {
    dispatch(openNewForm(form.formulario, form.nombre));
  };

  return (
    <StyledAddDocumentationCards.Container>
      {loading ? (
        <CircularLoading />
      ) : data.length === 0 ? (
        <StyledAddDocumentationCards.NoDataMessage variant="body2">
          No hay documentos disponibles.
        </StyledAddDocumentationCards.NoDataMessage>
      ) : (
        data.map((form) => (
          <StyledAddDocumentationCards.Card key={form.formulario}>
            <Typography variant="body2">{form.nombre}</Typography>
            <StyledAddDocumentationCards.ButtonsContainer>
              {form.formulario === "Idr" ?
                (
                  <Tooltip title="Agregar documento qr" arrow="top">
                    <StyledAddDocumentationCards.Button>
                      <StyledAddDocumentationCards.Icon as={QrCode2Icon}
                        onClick={() => handleOpenAddFormQr(form)}
                      />
                    </StyledAddDocumentationCards.Button>
                  </Tooltip>
                )
                : null
              }
              <Tooltip title="Agregar documento" arrow="top">
                <StyledAddDocumentationCards.Button>
                  <StyledAddDocumentationCards.Icon
                    onClick={() => handleOpenAddForm(form)}
                  />
                </StyledAddDocumentationCards.Button>
              </Tooltip>
            </StyledAddDocumentationCards.ButtonsContainer>
          </StyledAddDocumentationCards.Card>
        ))
      )}
      <OpenFormQRDialogContainer
        form={qrForm}
        open={Boolean(qrForm)}
        onClose={() => setQRform(null)}
      />
    </StyledAddDocumentationCards.Container>
  );
};

export default AddDocumentationCards;
